import { getAccessToken } from '@gef-ui/redux-common/selectors/appContext';
import path from "ramda/es/path";
import compose from "ramda/es/compose";
import concat from "ramda/es/concat";
import defaultTo from "ramda/es/defaultTo";
import dissocPath from "ramda/es/dissocPath";
import o from "ramda/es/o";
import of from "ramda/es/of";
import ramdaUseWith from "ramda/es/useWith";
import when from "ramda/es/when";
import zipObj from "ramda/es/zipObj";
import isNotNil from "ramda-extension/es/isNotNil";
import { AUTH_HEADER_NAME, AUTH_SCHEMA_BEARER } from '../../constants';
const defaultToEmptyObject = defaultTo({});
const createAuthHeader = ramdaUseWith(zipObj, [
    of(Array),
    o(of(Array), concat(`${AUTH_SCHEMA_BEARER} `))
]);
export const authHeaderFactory = (tokenSelector = getAccessToken, authHeaderName = AUTH_HEADER_NAME)=>compose(defaultToEmptyObject, when(isNotNil, createAuthHeader(authHeaderName)), tokenSelector);
const onErrorPath = [
    'actions',
    'onError'
];
export const dissocOnError = dissocPath(onErrorPath);
export const getOnError = path(onErrorPath);
